import { Hammer, ShieldCheck, Wrench, ArrowUpRight } from "lucide-react";

const SERVICES = [
  {
    icon: Hammer,
    title: "Reforma y optimización",
    text: "Asumimos los costes de reforma necesarios para revalorizar tu vivienda y convertirla en un activo de alto rendimiento.",
    points: [
      "Visita técnica y propuesta de mejora",
      "Coste de la reforma a nuestra cuenta",
      "Revalorización del inmueble incluida",
    ],
  },
  {
    icon: ShieldCheck,
    title: "Nos convertimos en tu inquilino",
    text: "Firmamos un contrato directo contigo. Tú cobras tu renta a principio de cada mes, esté ocupada o no la vivienda.",
    points: [
      "Pago puntual garantizado",
      "Cero riesgo de impago",
      "Contrato claro, sin letra pequeña",
    ],
  },
  {
    icon: Wrench,
    title: "Gestión integral 24h",
    text: "Nos encargamos de inquilinos, mantenimiento, incidencias y trámites. Tú no recibes llamadas, ni emails, ni problemas.",
    points: [
      "Equipo técnico disponible 24 horas",
      "Selección y filtrado de inquilinos",
      "Reporte y comunicación transparente",
    ],
  },
];

export default function Services() {
  return (
    <section
      id="servicios"
      data-testid="services-section"
      className="nr-section nr-bg-soft"
    >
      <div className="nr-container">
        <div className="max-w-2xl mb-14">
          <span className="nr-eyebrow">¿Por qué THE NEXT ROOM?</span>
          <h2 className="nr-h2 mt-4">
            La forma inteligente de alquilar tu piso, sin riesgo y sin gestión.
          </h2>
          <p className="mt-5 text-[16px] nr-text-soft">
            Tres pilares que trabajan juntos para garantizarte ingresos
            estables, una vivienda mejor cuidada y cero preocupaciones.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {SERVICES.map((s, i) => (
            <div
              key={s.title}
              data-testid={`service-${i}`}
              className="nr-service-card flex flex-col"
            >
              <div className="nr-service-icon">
                <s.icon size={22} strokeWidth={1.8} />
              </div>
              <h3 className="nr-h3">{s.title}</h3>
              <p className="mt-3 text-[14px] nr-text-soft leading-relaxed">
                {s.text}
              </p>
              <ul className="mt-6 space-y-2.5 text-[14px] text-[#111]">
                {s.points.map((p) => (
                  <li key={p} className="flex items-start gap-2.5">
                    <span className="mt-2 inline-block h-1 w-3 bg-[#43A4A8] rounded-full" />
                    <span>{p}</span>
                  </li>
                ))}
              </ul>
              <div className="mt-8 pt-6 border-t border-[#EAEAEA]">
                <a href="#contacto" className="nr-link">
                  Saber más <ArrowUpRight size={14} />
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
